import ItemsBlock from './itemsBlock'

export default ItemsBlock
